import { Component, Input, ChangeDetectionStrategy, HostBinding } from '@angular/core';
import { NavigationItem, toggleNavSection } from 'src/app/store/navigation';
import { ActivatedRoute, Router } from '@angular/router';
import { trigger, state, style, transition, animate, group } from '@angular/animations';
import { Store } from '@ngrx/store';
import { makeSlideInOut } from '../../utils/animations';


declare const $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: '[smart-nav-item]',
  templateUrl: './nav-item.component.html',
  animations: [makeSlideInOut()],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavItemComponent {

  @Input() item: NavigationItem;
  @Input() minified: boolean;

  @HostBinding('class.active') get active() { return this.item.active; }
  @HostBinding('class.open') get open() { return this.item.open; }
  @HostBinding('class.js-filter-hide]') get hidden() { return this.item.matched !== null && !this.item.matched; }
  @HostBinding('class.js-filter-show]') get shown() { return this.item.matched !== null && this.item.matched; }
  @HostBinding('class.nav-title]') get navTitle() { return this.item.navTitle; }


  constructor(
    private router: Router,
    private store: Store<any>
  ) {
    // console.log("this.item==>", this.item)
  }

  toggleSection($event: MouseEvent, id) {
    // this.showPlot(id);

    $event.preventDefault();
    this.store.dispatch(toggleNavSection({ item: this.item }));
    // console.clear()
    // console.log("item.....>>>>", this.item)
  }

  trackByFn(idx: number, item: NavigationItem) {
    return item.title + '_' + idx;
  }

  focus($event: MouseEvent, id) {
    // console.log(":ASDASdasd", id)
    var element = document.getElementById("clickConfigFarm" + id);
    if (element != null) {
      element.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    }
  }

  showPlot(id) {
    // console.log("...showPlot(id)..>>>", id)
    var element = document.getElementById("clickConfigFarm" + id);
    if (element != null) {
      element.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    }


    // console.log("element", element + id);

    $('#plot-' + id).removeClass("dis-none");
    $('#pnShowbtn' + id).addClass('dis-none');

    let hasClass = $('#menuSubFarm' + id).hasClass("d-block");
    if (hasClass == true) {
      $('#plot-' + id).addClass("dis-none");
      $('#pnShowbtn' + id).removeClass('dis-none');
    }
  }

  focusFarm(id, path, param) {
    // console.log("...focusFarm(id)..>>>", id, path)
    // console.log("...focusFarm(id).. param>>>", param)
    if (id != undefined) {

      var element = document.getElementById("clickConfigFarm" + id);

      if (element != null) {
        element.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
      }
    }
    if (path.indexOf("#/home") == -1) {
      // console.log("focusFarm(id) path ", path)
      if (param) {
        this.router.navigate(["/" + path], { queryParams: { farmId: param.farmId, plotId: param.plotId, cropId: param.cropId, zoneId: param.zoneId } }).then(() => {
          window.location.reload();
        });
      }else{
      this.router.navigate(["/" + path]).then(() => {
        window.location.reload();
      });

      }
    }
  }

}
